"use client";

import { OBSERVERS, registerAll } from "@/rules/register";

// Registered at module load so events and plugins are in place before any component renders
registerAll();

export default function RulesBootstrap({ children }: { children: React.ReactNode }) {
  return (
    <>
      {OBSERVERS.map((Observer, index) => (
        <Observer key={index} />
      ))}
      {children}
    </>
  );
}
